const mutations = {
    insertProductionRecipeInfoLijst(state, lijst) {
        state.prodRecipeInfoLijst = [];
        if (lijst != undefined) {
            state.prodRecipeInfoLijst = lijst;
        }
    },
    deleteProductionRecipe(state, item) {
        const index = state.prodRecipeInfoLijst.findIndex((x) => {
            return x.id === item.id;
        });
        if (index > -1) {
            state.prodRecipeInfoLijst.splice(index, 1);
        }
    },
    insertIngredientProductionLijst(state, lijst) {
        state.prodIngrProdInfoLijst = [];
        if (lijst != undefined) {
            state.prodIngrProdInfoLijst = lijst;
        }
    }
};

export default mutations;
